export default __webpack_public_path__ + "static/media/cameraH.5ce943e3.png";